import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PaceCoreModule } from '@evorait/pace-core';
import { SmartlockerComponent } from './components/smartlocker/smartlocker.component';
import { SmartlockerDeliveryComponent } from './components/smartlocker/smartlocker-delivery/smartlocker-delivery.component';
import { SmartlockerAccessCodeComponent } from './components/smartlocker-access-code/smartlocker-access-code.component';
import { SmartlockerTransferComponent } from './components/smartlocker-transfer/smartlocker-transfer.component';
import { LetDirective } from '@ngrx/component';
import { SmartlockerPickupComponent } from './components/smartlocker-pickup/smartlocker-pickup.component';
import { SmartlockerPickupDetailsComponent } from './components/smartlocker-pickup/smartlocker-pickup-details/smartlocker-pickup-details.component';

@NgModule({
    declarations: [
        SmartlockerComponent,
        SmartlockerDeliveryComponent,
        SmartlockerAccessCodeComponent,
        SmartlockerTransferComponent,
        SmartlockerPickupComponent,
        SmartlockerPickupDetailsComponent,
    ],
    imports: [CommonModule, SharedModule, PaceCoreModule.forChild(), LetDirective],
})
export class SmartlockerModule {}
